import styled from "styled-components";


export const InputGroup = styled.div`
  margin-top: 0;
  padding-top: 10px;
`;